import {EntityType} from "../../../gd/const/item"
import Document from "../../../model2/doc/document"
import Relation from "../../../model2/relation/relation"
import projectRouteUrl from "./project-route-url"
import documentRouteUrl from "./document-route-url"

// Root-relative route (leading '/') for the related item, as a string for gd.openInNewWindow.
// A bare 't/x' resolves against the current page, giving '/t/t/x' from a task.
// MIRRORS `go-to-item.ts` -- add a type there and add it here too.
export default function itemRouteUrl(relation: Relation): string {
    const item = relation.relatedItem

    switch (relation.itemType) {
        case EntityType.TASK    : return '/t/' + item.id
        case EntityType.PROJECT : return projectRouteUrl(relation)
        case EntityType.EVENT   : return '/event/' + item.id
        case EntityType.MEETING : return '/m/' + item.id
        case EntityType.DOCUMENT: return documentRouteUrl(item as Document)
        case EntityType.GOAL    : return '/goal/' + item.id
        default                 : return ''
    }
}
